import { useMutation } from "@tanstack/react-query";
import { postExistingHfrToClinic } from "apis";
import { getMyProfileQueryKeys } from "../get-my-profile";
import queryClient from "../../../instances/react-query-client";

const usePostExistingHfrToClinic = () => {
  return useMutation({
    mutationFn: postExistingHfrToClinic,
    onSuccess: ({ success }) => {
      if (success) {
        queryClient.invalidateQueries(getMyProfileQueryKeys());
      }
    },
  });
};

export default usePostExistingHfrToClinic;
